import React from 'react'
import PropTypes from 'prop-types'
import ReactToPrint from 'react-to-print'
import { useSelector } from 'react-redux'
import { Grid, Box, Typography, Stack, Button } from '@mui/material'
import { PRINT_DIALOG_TYPES } from 'utils/constants'
import { MediaNoPrintWrapper, ActionButtons, ContainerGrid } from './generic'
import LogoAddress from './LogoAddress'

const PrintDialogTitle = ({
  refDialog,
  refPrintButton,
  onCloseDialog,
  title,
  dialogType,
  shouldPrintTitle,
  logoUrl,
  onAfterLoadLogo,
  showLogoAddress,
  onAfterPrint,
}) => {
  const { enablePullApartFeatures } = useSelector(state => state.featureFlags?.variables || {})
  const Title = () => (
    <Grid item>
      <Typography variant={enablePullApartFeatures ? 'h5' : 'h6'}>
        {enablePullApartFeatures ? <strong>{title}</strong> : title}
      </Typography>
    </Grid>
  )
  return (
    <ContainerGrid alignItems="center" justifyContent="space-between" flexWrap="wrap-reverse">
      <Grid item py={1.3} width="100%">
        <Stack direction="column" width="100%" alignItems="flex-start">
          {dialogType.key === PRINT_DIALOG_TYPES.TAG.key && (
            <ReactToPrint
              trigger={() => <Button ref={refPrintButton} sx={{ position: 'absolute' }} />}
              onAfterPrint={() => {
                onAfterPrint()
                onCloseDialog()
              }}
              content={() => refDialog.current}
            />
          )}
          <Box display="flex" alignItems="center" justifyContent="space-between" width="100%" mb={1}>
            <LogoAddress
              dialogType={dialogType}
              logoSrc={logoUrl}
              onAfterLoadLogo={onAfterLoadLogo}
              showLogoAddress={showLogoAddress}
            />
          </Box>
          {!shouldPrintTitle ? (
            <MediaNoPrintWrapper>
              <Title />
            </MediaNoPrintWrapper>
          ) : (
            <Title />
          )}
          {dialogType.key !== PRINT_DIALOG_TYPES.TAG.key && (
            <ActionButtons
              refDialog={refDialog}
              refPrintButton={refPrintButton}
              onCloseDialog={onCloseDialog}
              onAfterPrint={onAfterPrint}
            />
          )}
        </Stack>
      </Grid>
    </ContainerGrid>
  )
}

PrintDialogTitle.propTypes = {
  dialogType: PropTypes.object,
  refDialog: PropTypes.any.isRequired,
  refPrintButton: PropTypes.any.isRequired,
  onCloseDialog: PropTypes.func.isRequired,
  title: PropTypes.string,
  shouldPrintTitle: PropTypes.bool,
  logoUrl: PropTypes.string,
  onAfterLoadLogo: PropTypes.func,
  showLogoAddress: PropTypes.bool,
  onAfterPrint: PropTypes.func,
}

PrintDialogTitle.defaultProps = {
  dialogType: PRINT_DIALOG_TYPES.COMMON,
  title: '',
  shouldPrintTitle: true,
  logoUrl: '',
  onAfterLoadLogo: () => {},
  showLogoAddress: false,
  onAfterPrint: () => {},
}

export default PrintDialogTitle
